module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_back.ee12e455.svg";